import { AnimationType } from '@/models/games/BaseAnimation';
import { CarnivalTreasureResult } from '@/models/games/carnivalTreasure';
import { GameType } from '@/models/games/enums/GameType';
import { TableMode } from '@/models/TableMode';
import { animationSliceActions } from '@/modules/animation/slice';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import {
    convertDetailResultString,
    convertResultToRecord,
} from '@/utils/games/carnivalTreasure';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import { CMDScInitCarnivaltreasure, ICommand } from '../live';
import { CMDCarnivaltreasure } from '../live/CMDCarnivaltreasure';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitCarnivaltreasureHandler extends AbstractHandler {
    _command: CMDScInitCarnivaltreasure;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitCarnivaltreasure;
    }

    override convertResult(
        result: CMDCarnivaltreasure
    ): CarnivalTreasureResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            convertDetailResultString(result.Detail.ResultString)
        ) as CarnivalTreasureResult;

        return newResult;
    }

    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        liveData.GameType = GameType.CarnivalTreasure;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if (o.BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );

        liveData.ResultReleased = false;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;

        const convertedRecord = game.OldResult.map(r =>
            convertResultToRecord(r as CarnivalTreasureResult)
        );

        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseResult.GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record:
                        convertedRecord.length > 50
                            ? convertedRecord.splice(
                                  convertedRecord.length - 50
                              )
                            : convertedRecord,
                })
            );

            if (liveData.CurrentResult) {
                const gr = liveData.CurrentResult as CarnivalTreasureResult;
                const mf = Number(gr.MultipliterFinal);
                if (mf > 1) {
                    dispatch(
                        animationSliceActions.init({
                            hostId: hostId,
                            init: [],
                        })
                    );
                    dispatch(
                        animationSliceActions.save({
                            hostId: hostId,
                            last: {
                                animationType: AnimationType.CT_INIT,
                                initialPayouts: gr.Odds,
                            },
                        })
                    );
                } else {
                    dispatch(animationSliceActions.reset(hostId));
                    dispatch(
                        animationSliceActions.save({
                            hostId: hostId,
                            last: {
                                animationType: AnimationType.STOP,
                                initialPayouts: [],
                            },
                        })
                    );
                }
            }
        });
    }
}
